import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus, Pencil } from "lucide-react";
import { PageHeader, GlassCard, GradButton, EmptyState, ConfirmDelete, fmtMoney } from "@/components/erp";
import { ReceteDialog } from "@/components/ReceteDialog";
import { useAuth } from "@/context/AuthContext";
import api, { errMsg } from "@/lib/api";

const BOS = { urun_id: "", ad: "", cikti_miktari: 1, satirlar: [], aktif: true, notlar: "" };

export default function Receteler() {
  const { ayar, isYonetim } = useAuth();
  const [list, setList] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = useCallback(async () => {
    const [r, u] = await Promise.all([api.get("/receteler"), api.get("/urunler")]);
    setList(r.data); setUrunler(u.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const del = async (id) => {
    try { await api.delete(`/receteler/${id}`); toast.success("Silindi"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="receteler-page">
      <PageHeader eyebrow="Ana veri" title="Reçeteler & Maliyet" desc="Bileşen × (1 + fire %) × birim maliyet. Yarı mamul maliyetleri üst reçetelere otomatik yansır.">
        {isYonetim && <GradButton data-testid="recete-ekle" onClick={() => setEdit(BOS)}><Plus className="w-4 h-4" />Yeni reçete</GradButton>}
      </PageHeader>
      {list.length === 0 ? <GlassCard><EmptyState text="Henüz reçete yok. Önce hammadde ve mamul ürünlerini ekleyin." testid="recete-bos" /></GlassCard> : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
          {list.map((r, i) => (
            <GlassCard key={r.id} className="p-6 fade-up" style={{ animationDelay: `${i * 50}ms` }} data-testid={`recete-kart-${r.urun_kod}`}>
              <div className="flex justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-mono text-[11px] text-muted-foreground">{r.urun_kod}</div>
                  <h3 className="font-head font-semibold truncate">{r.urun_ad}</h3>
                </div>
                <span className={`h-fit text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full ${r.aktif ? "bg-emerald-500/15 text-emerald-400" : "bg-white/5 text-muted-foreground"}`}>{r.aktif ? "aktif" : "pasif"}</span>
              </div>
              <div className="mt-4 space-y-1.5">
                {r.satirlar.slice(0, 4).map((s, n) => (
                  <div key={n} className="flex justify-between text-xs"><span className="text-muted-foreground truncate">{s.urun_ad} · {s.miktar} {s.birim}{s.fire_yuzde ? ` (+%${s.fire_yuzde})` : ""}</span><span className="font-mono">{fmtMoney(s.tutar)}</span></div>
                ))}
                {r.satirlar.length > 4 && <div className="text-xs text-muted-foreground">+{r.satirlar.length - 4} bileşen</div>}
              </div>
              <div className="flex items-end justify-between mt-5 pt-4 border-t border-white/5">
                <div>
                  <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Birim maliyet ({r.cikti_miktari} çıktı)</div>
                  <div className="font-head text-2xl font-bold grad-text" data-testid={`recete-birim-${r.urun_kod}`}>{fmtMoney(r.birim_maliyet)}</div>
                </div>
                {isYonetim && <div className="flex">
                  <button data-testid={`recete-duzenle-${r.urun_kod}`} onClick={() => setEdit(r)} className="p-2 rounded-lg text-muted-foreground hover:text-white hover:bg-white/10"><Pencil className="w-4 h-4" /></button>
                  <ConfirmDelete testid={`recete-sil-${r.urun_kod}`} onConfirm={() => del(r.id)} />
                </div>}
              </div>
            </GlassCard>
          ))}
        </div>
      )}
      {edit && <ReceteDialog initial={edit} urunler={urunler} ayar={ayar} onClose={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} />}
    </div>
  );
}
